// extracted by mini-css-extract-plugin
module.exports = {"select":"style_select__1prJF","inputs":"style_inputs__2Jxnv"};